export const VEHICLE_TYPE_VALUES = [
  "motorcycle",
  "subcompact",
  "compact",
  "standard",
  "suv",
  "truck",
  "oversized",
] as const;

/**
 * Canonical vehicle size/type union. All other `VehicleSize` /
 * `VehicleType` / `SearchVehicleType` aliases across the app re-export this,
 * so the member list is defined exactly once — here.
 */
export type VehicleType = (typeof VEHICLE_TYPE_VALUES)[number];

export const VEHICLE_SIZES: { label: string; value: VehicleType }[] = [
  { label: "Motorcycle", value: "motorcycle" },
  { label: "Subcompact", value: "subcompact" },
  { label: "Compact", value: "compact" },
  { label: "Standard", value: "standard" },
  { label: "SUV", value: "suv" },
  { label: "Truck", value: "truck" },
  { label: "Oversized", value: "oversized" },
];

export const PARKING_TYPES = ["Driveway", "Garage", "Carport", "Indoor"];

export const AMENITIES = ["EV charger", "CCTV", "Gated"];
